import { apiFetch } from "./apiFetch";
import { getApiErrorMessage } from "./apiError";

const API_URL = process.env.REACT_APP_API_URL;

export async function getVendorDocuments(
  companyId: string,
  vendorId: string,
  page: number,
  pageSize: number
) {
  const skip = page * pageSize;

  const res = await apiFetch(
    `${API_URL}/vendors/${vendorId}/documents?companyId=${companyId}&skip=${skip}&top=${pageSize}`
  );

  if (!res.ok) {
    throw new Error(
      await getApiErrorMessage(res, "Nie udało się pobrać dokumentów dostawcy.")
    );
  }

  return res.json(); // 🔥 NIE data.items
}